import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, UrlTree, Router } from '@angular/router';
import { DurationRangeService } from '@app-core/services/duration-range/duration-range.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagGuard implements CanActivate {
  constructor(private durationRangeService: DurationRangeService, private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const requiredFeature = route.data['featureFlags'];
    const featureFlags = this.durationRangeService?.planDetails?.featureFlags || [];
    if (!this.durationRangeService?.planDetails) {
      return true;
    }
    if (!featureFlags.includes(requiredFeature)) {
      this.router.navigate(['home']);
      return false;
    }
    return true;
  }
}
